var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2812 3.28126C17.5312 4.00001 17.5 4.18751 17.5 8.28126V12.5H40.0312H62.5625L62.4375 8.09376C62.3437 3.90626 62.3125 3.65626 61.5937 3.09376C60.9062 2.53126 60.0625 2.50001 39.9375 2.50001H19.0312L18.2812 3.28126Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 15.6875C18.2188 17.25 10.625 54.5 10.625 54.75C10.625 54.875 12.5 55 14.8125 55H19L19.1875 53.8125C19.625 51.1563 24.375 16.125 24.375 15.5938C24.375 15.0625 24.0938 15 21.5625 15C18.9062 15 18.75 15.0313 18.5938 15.6875Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0633 15.375C27.0008 15.5938 25.7821 24.2813 24.4071 34.6875C23.0008 45.0938 21.7821 53.9063 21.6883 54.2813C21.5633 55 21.5633 55 25.2196 55H28.9071L30.1258 37.25C30.7821 27.5 31.3758 18.5 31.4696 17.25L31.6571 15H29.4071C27.8758 15 27.1258 15.125 27.0633 15.375Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0625 16C34.0625 16.5625 33.5 25.125 32.8125 35C32.125 44.875 31.5625 53.4375 31.5625 53.9688V55H35.1562H38.75V35V15H36.4062H34.0625V16Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 35V55H44.8438H48.4375V53.9688C48.4375 53.4375 47.875 44.875 47.1875 35C46.5 25.125 45.9375 16.5625 45.9375 16V15H43.5938H41.25V35Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 17.25C48.5938 18.5 49.2188 27.5 49.875 37.25L51.0938 55H54.75H58.4062L58.25 54C58.1562 53.4375 56.9375 44.4688 55.5 34.0625L52.9375 15.1562L50.625 15.0625L48.3438 14.9688L48.5 17.25Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.625 15.5938C55.625 16.1563 60.375 51.1563 60.8125 53.8125L61 55H65.1875C67.5 55 69.375 54.875 69.375 54.75C69.375 54.5 61.7812 17.25 61.4062 15.6875C61.25 15.0313 61.0938 15 58.4375 15C55.875 15 55.625 15.0625 55.625 15.5938Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 61.6875C7.5 65.3438 7.5625 65.9688 8.09375 66.5938L8.6875 67.3438L39.7812 67.4375C70.0312 67.5 70.875 67.5 71.5938 66.9063C72.3125 66.3438 72.3438 66.0938 72.4375 61.9063L72.5625 57.5H40.0312H7.5V61.6875Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 73.75V77.5H40H57.5V73.75V70H40H22.5V73.75Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirFilter);
export default __webpack_public_path__ + "static/media/air-filter.2c7d7c46168af2d2be8d58de59807222.svg";
export { ForwardRef as ReactComponent };